import React from "react";
import PropTypes from "prop-types";
import { trans } from "../../helpers/index";

const B2bInfoList = ({ banInfo, b2bTrans }) => {
  let businessName = banInfo.data.ban_info.business_name,
    address = banInfo.data.ban_info.address,
    contactNumber = banInfo.data.ban_info.contact_number,
    contactEmail = banInfo.data.ban_info.email_address;

  businessName = (
    <li className="main-wrapper__b2b-info-item main-wrapper__b2b-info-item--case fs20 sprite-b pr">
      {!businessName || businessName === "null"
        ? trans(b2bTrans, "b2b.not_available.title")
        : businessName}
    </li>
  );

  address = (
    <li className="main-wrapper__b2b-info-item main-wrapper__b2b-info-item--location fs20 sprite-b pr">
      {!address || address === "null"
        ? trans(b2bTrans, "b2b.not_available.title")
        : address}
    </li>
  );

  contactNumber = (
    <li className="main-wrapper__b2b-info-item main-wrapper__b2b-info-item--tel fs20 sprite-b pr">
      {!contactNumber || contactNumber === "null"
        ? trans(b2bTrans, "b2b.not_available.title")
        : contactNumber}
    </li>
  );

  contactEmail = (
    <li className="main-wrapper__b2b-info-item main-wrapper__b2b-info-item--email fs20 sprite-b pr">
      {!contactEmail || contactEmail === "null"
        ? trans(b2bTrans, "b2b.not_available.title")
        : contactEmail}
    </li>
  );

  return (
    <ul className="main-wrapper__b2b-info-list ver-top-box">
      {businessName}
      {address}
      {contactNumber}
      {contactEmail}
    </ul>
  );
};

B2bInfoList.propTypes = {
  banInfo: PropTypes.object,
  b2bTrans: PropTypes.object,
};

export default B2bInfoList;
